export enum GoalModal {
  create = "GOAL_CREATE",
  update = "GOAL_UPDATE"
}
